import { Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AuthArtwork from 'src/layouts/AuthArtwork';
import { AUTH_ARTWORK } from 'src/layouts/auth-artwork-content';
import {
  WelcomeArtwork,
  WelcomeHeading,
  WelcomeHeadingLine,
  WelcomePanel,
} from './styles';

interface OwnerLoginWelcomeProps {
  onArtworkReady: () => void;
}

export default function OwnerLoginWelcome({
  onArtworkReady,
}: OwnerLoginWelcomeProps): JSX.Element {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <WelcomePanel
      aria-labelledby="owner-login-welcome-heading"
      data-testid="owner-login-welcome"
    >
      <WelcomeHeading>
        <Typography
          id="owner-login-welcome-heading"
          component="h2"
          variant="h2"
          sx={{
            fontWeight: 800,
            lineHeight: 1.08,
            letterSpacing: '-0.04em',
            fontSize: {
              xs: theme.typography.h4.fontSize,
              sm: theme.typography.h3.fontSize,
              lg: theme.typography.h2.fontSize,
              xl: theme.typography.h1.fontSize,
            },
          }}
        >
          <WelcomeHeadingLine>
            {t('ownerLogin.welcomeLine1')}
          </WelcomeHeadingLine>
          <br />
          <WelcomeHeadingLine>
            {t('ownerLogin.welcomeLine2')}
          </WelcomeHeadingLine>
        </Typography>
      </WelcomeHeading>
      <WelcomeArtwork
        data-testid="owner-login-illustration"
        aria-hidden="true"
      >
        <AuthArtwork
          {...AUTH_ARTWORK.ownerWelcome}
          onArtworkReady={onArtworkReady}
        />
      </WelcomeArtwork>
    </WelcomePanel>
  );
}
